import { NoInfer, RecursivePartial } from "@store/Framework/Types/Common";
import mergeWith from "lodash/mergeWith";

function overrideProps<T, U>(object1: T | undefined, object2: U | undefined): T & U;
function overrideProps<T>(object1: RecursivePartial<NoInfer<T>> | undefined, object2: NoInfer<T> | undefined): T;
function overrideProps<T>(object1: NoInfer<T> | undefined, object2: RecursivePartial<NoInfer<T>> | undefined): T {
    return mergeWith({}, object1, object2, (object: any, source: any) => {
        if (Array.isArray(object)) {
            return source;
        }
    });
}

export default overrideProps;
